import { DiscountActionState, DiscountActionFormStatus, SavedDiscountAction, SavedDiscountBand, DiscountActionForm, DiscountTarget, EditableBandedDiscount } from "app/pages/DiscountEditor/modules/DiscountActions/state";
import { DiscountValueType, DiscountActionTargetTypeEnum, Currency, DiscountBandTypeEnum } from "app/shared/model";
import { ProductSelectionState } from "app/pages/DiscountEditor/modules/ProductSelection/state";
import { getSelectedCurrencies, getSelectedSchools } from "app/pages/DiscountEditor/modules/ProductSelection";
import { ProductFilterType, SelectionMap, ProductFilter, productFilterToDto } from "app/shared/model/ProductFilter";
import { Fee } from "app/shared/model/Fee";
import { saveDiscountAction } from "app/pages/DiscountEditor/actions";
import { DiscountActionDto, ProductFilterDto } from "app/shared/model/DiscountDto";
import { toFeeCodeDto } from "app/pages/DiscountEditor/modules/DiscountActions/feeCodes";


function getRoot(state: any) : DiscountActionState {
    return state.discountActions;
}

export function showNewDiscountActionWizard(state: any) {
    return getRoot(state).form.status == DiscountActionFormStatus.AddNewDiscountAction;
}

export function showDeleteActionConfirmationModal(state: any) {
    return getRoot(state).form.status == DiscountActionFormStatus.DeleteConfirmation; 
}

export function getSavedDiscountActions(state: any) : SavedDiscountAction[] {
    const root = getRoot(state); 
    return Object.keys(root.actions.items)
        .map((id: string) => {
            return root.actions.items[id]; 
        });
}

function getAmountOffDisabledMessage(
    isSchoolSelected: boolean, 
    selectedCurrencies: Currency[]) : string | undefined
{
    if (!isSchoolSelected) 
        return "No school selected"
    
    if (selectedCurrencies.length !== 1)
        return "Multiple currencies found"
    
    return undefined; 
} 

export function showBandedDiscountDialog(state: any) {
    const root = getRoot(state);
    return root.form.status == DiscountActionFormStatus.AddOrEditDiscountBands;
}

export function getFees(state: any) : Fee[] {
    return getRoot(state).fees;
}

function getForm(state: any) : DiscountActionForm {
    return getRoot(state).form;
}

export function getDiscountActionDtos(state: any) : DiscountActionDto[] {
    const root = getRoot(state);
    return Object.keys(root.actions.items)
        .map(k => root.actions.items[k])
        .map(a => {
            const isDiscrete = a.bandType === DiscountBandTypeEnum.Discrete;
            const dto: DiscountActionDto = {
                id: a.id,
                isNew: a.isNew,
                target: a.target.type,
                valueType: a.valueType,
                bandType: a.bandType,
                bands: a.bands.map(b => {
                    const band: { minUnits: number; maxUnits?: number; value: number } = {
                        minUnits: b.minUnits,
                        value: b.value
                    };
                    if (!isDiscrete && b.maxUnits != null) {
                        band.maxUnits = b.maxUnits;
                    }
                    return band;
                }),
                feeCodes: a.target.type === DiscountActionTargetTypeEnum.Fees 
                    ? Object.keys(a.target.fees).map(toFeeCodeDto)
                    : undefined,
                productFilter: a.target.type === DiscountActionTargetTypeEnum.OtherProducts
                    ? productFilterToDto(a.target.products)
                    : undefined
            };

            if ((a.valueType === DiscountValueType.AmountPerUnit || a.valueType === DiscountValueType.OverrideUnitPrice) && a.currencyCode) {
                dto.currencyCode = a.currencyCode;
            }
            
            return dto;
        });
}

export function getDiscountActionIdToDelete(state: any) : string|undefined {
    const form = getRoot(state).form;
    if (form.status !== DiscountActionFormStatus.DeleteConfirmation)
        return undefined;
    return form.id;
}

export function getDiscountActionToEdit(state: any) : EditableBandedDiscount|undefined {
    const form = getRoot(state).form;
    if (form.status !== DiscountActionFormStatus.AddOrEditDiscountBands)
        return undefined;

    return form.discount;
}